import React, { useState, useEffect } from "react";
import { Box, Grid2, Typography , Paper,InputBase,Button, buttonBaseClasses} from "@mui/material";
import CloseButton from "../../../ui-utils/latestPics/close button.svg";
import SticktStyles from "./StickyBar.module.css"
import { backendHosts } from "../../../ui-utils/apiConfig"
import validator from "validator";
import { useLanguage } from "../../../Context/LangContext";

import en from "../../../i18n/English/Home/sticky.json";
import hi from "../../../i18n/Hindi/Home/sticky.json";
import kn from "../../../i18n/Kannada/Home/sticky.json";
import ma from "../../../i18n/Marathi/Home/sticky.json";
import gu from "../../../i18n/Gujarati/Home/sticky.json";

const StickyBar = () => {
    const [showBar, setShowBar] = useState(false);
    const [isClosed, setIsClosed] = useState(false);

    const [mobileNo, setMobileNo] = useState("");
    const clientErr = {};
    const [mobClientErr, setMobileClientErr] = useState({});
      const { language } = useLanguage();
      const translations = { en, hi, kn,ma,gu };
      const t = translations[language];

    const handleMobilenoEnter = () => {
        const formData = { mobileNo };
        console.log(formData);
        const runValidation = () => {
            if (mobileNo.trim().length == 0) {
                clientErr.mobileNo = "Please Enter your mobile number";
                return;
            }
            if (!validator.isMobilePhone(mobileNo, "en-IN")) {
                console.log("false")
                clientErr.mobileNo = "Please Enter Valid mobile number";
                return;
            }
        };
        runValidation();
        if (Object.keys(clientErr).length == 0) {

            const fullUrl = `${backendHosts.REG}/?mobilenofromhome=${mobileNo}&t=${Date.now()}`;
            window.location.href = fullUrl;
            setMobileClientErr({});

        } else {
            setMobileClientErr(clientErr);
        }
    };

    const handleMobileNoChange = (e) => {
        const inputValue = e.target.value;
        const numericValue = inputValue.replace(/\D/g, "");
        const limitedValue = numericValue.slice(0, 10);

        setMobileNo(limitedValue);
      };


    const handleScroll = () => {
        const scrollPosition = window.scrollY;
        const totalHeight = document.documentElement.scrollHeight;
        const viewportHeight = window.innerHeight;


        const scrollThreshold = viewportHeight * 0.90;


        if (!isClosed && scrollPosition > scrollThreshold) {
            setShowBar(true);
        } else {
            setShowBar(false);
        }
    };


    useEffect(() => {

        window.addEventListener("scroll", handleScroll);


        return () => window.removeEventListener("scroll", handleScroll);
    }, [isClosed]);

    return (
        <Box style={{ display: "flex", flexDirection: "column" }}>
            {showBar && (
                <>
                    <Grid2
                       className={SticktStyles.mainCard}
                    >
                        <Grid2 className={SticktStyles.innerBox} >

                            <Box>
                                <Typography className={SticktStyles.content1} style={{ fontWeight: 600 }}>
                                    {/* Hey, Why Not Start Investing Today? */}
                                     {t.heading}
                                </Typography>
                                <Typography className={SticktStyles.content2}>
                                    {/* Open A Demat Account In 7 minutes */}
                                    {t.subheading}
                                </Typography>
                            </Box>


                            <Paper component="form" className={SticktStyles.mobilefield}>
                                <Typography className={SticktStyles.preMobile}>91</Typography>
                                <InputBase
                                    aria-label="Mobile number"
                                    className={SticktStyles.inputbase}
                                    placeholder={t.placeholder}
                                    value={mobileNo}
                                    onChange={handleMobileNoChange}
                                />
                                <Button className={SticktStyles.dematButton} onClick={handleMobilenoEnter}>
                                    {/* Open a Demat Account in 7 minutes */}
                                    {t.button}
                                </Button>
                            </Paper>
                        </Grid2>


                        <Button
                            aria-label="Close sticky bar"
                            onClick={() => {
                                setShowBar(false);
                                setIsClosed(true);
                            }}
                            className={SticktStyles.closeButton}
                        >
                            <img
                                src={CloseButton}
                                alt="CloseButton"
                                aria-hidden="true"
                            />
                        </Button>
                    </Grid2>
                </>
            )}
        </Box>

    );
};

export default StickyBar;
